import { Subject } from 'rxjs'

export interface LoadingPayload {
  key: string
  isLoading: boolean
}

export const loading = new Subject<LoadingPayload>()
